export default "__VITE_ASSET__RPYun1nm__"